module.exports = __webpack_public_path__ + "static/card-truck-text-alerts-77e4aab1ac93a528f3fdf3c24b152c1f.jpg";